import { EnvVarEnum } from '@gtpl/shared-models/common-models';
import {appSettings} from '../../../../../apps/services/config';
const envType = 'DEV';//EnvVarEnum[process.env.NX_ENVIRONMENT.toLocaleUpperCase()];
// const url = process.env[`NX_PMS_` + envType + `_SERVICE_URL`];
const url=appSettings.sales_url;//'http://206.189.138.212:3333/erpx';
//const url='http://localhost:5002/erpx';
export const connection = {
    'DEPLOY_URL': url,
    // 'userid':JSON.parse(localStorage.getItem('userid')),
    // 'role':JSON.parse(localStorage.getItem('role'))
}

export default connection;
